import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type {
  SupplierConditionsClient,
  SupplierConditionsDto,
} from '@/api/supplier-conditions-client';
import { useSupplierConditionsClient } from '@/api/supplier-conditions-client-context';

// =============================================================================
// use-supplier-conditions.ts — Hook TanStack Query de la page « Conditions de référencement » (§3.3, F2).
// =============================================================================
// Lecture PURE (useQuery). Le client effectif vient du SupplierConditionsClientProvider (doublable).
// ZÉRO règle métier : l'autorité (session/withTenant, agrégation périmètre / statut cycle / tri) est l'API.
// Aucune donnée métier en localStorage (RULE_REF_006).

const SUPPLIER_CONDITIONS_KEY = ['supplier-conditions'] as const;

/** Clé de query de la page conditions fournisseur. */
export function supplierConditionsKey(): readonly unknown[] {
  return [...SUPPLIER_CONDITIONS_KEY];
}

/** GET page « Conditions de référencement » du fournisseur en session (briefings des campagnes). */
export function useSupplierConditions(): UseQueryResult<
  SupplierConditionsDto,
  Error
> {
  const client: SupplierConditionsClient = useSupplierConditionsClient();
  return useQuery<SupplierConditionsDto, Error>({
    queryKey: supplierConditionsKey(),
    queryFn: () => client.getConditions(),
  });
}
